import React, { useState } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import PieChartHbb from "./pieChartHbb";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Button from "@mui/material/Button";
import EbuCbuPieChartTwoHbb from "./eBuCbuPieChartTwoHbb";
import ServiceCategoryPieChartHbb from "./serviceCategoryPieChartHbb";
import HBBPlansTable from "./hbbPlanTable";
import HBBPlansCategoryTable from "./hbbPlanCategoryTable";

am4core.useTheme(am4themes_animated);

export default function TraingleColumnChartHbb(props) {
  const { getCategoryPlans = () => {} } = props;
  const [showEbuCbu, setShowEbuCbu] = useState(false);
  const [showColumnChart, setShowColumnChart] = useState(false);
  const [nav, setNav] = useState([""]);
  const [tableDataType, setTableDataType] = useState("");

  const handleTypesClick = () => {
    setShowEbuCbu(false);
    setShowColumnChart(false);
  };

  const handleCbuClick = () => {
    setShowColumnChart(true);
  };

  const onNext = (next) => {
    const newNav = [...nav, next];
    setNav(newNav);
  };

  const onJump = (index) => {
    const newNav = index ? [...nav].slice(0, index + 1) : [""];
    setNav(newNav);
  };

  return (
    <div style={{ width: "100%" }}>
      {nav.length > 1 ? (
        <Breadcrumbs aria-label="breadcrumb" style={{ marginTop: 16 }}>
          {nav.map((n, index) => {
            return (
              <Button
                disabled={index + 1 === nav.length}
                color="primary"
                size="small"
                onClick={() => onJump(index)}
              >
                {n || "Types"}
              </Button>
            );
          })}
          {showColumnChart ? (
            <Button disabled color="inherit" size="small" onClick={() => null}>
              Sales
            </Button>
          ) : null}
        </Breadcrumbs>
      ) : null}
      {nav.length === 1 && (
        <PieChartHbb
          {...props}
          showEbuCbu={showEbuCbu}
          setShowEbuCbu={setShowEbuCbu}
          showColumnChart={showColumnChart}
          setShowColumnChart={setShowColumnChart}
          onNext={onNext}
        />
      )}

      {nav.length === 2 && nav[nav.length - 1] == "All" && (
        <div style={{ display: "flex", flexDirection: "row" }}>
          {[
            { label: [...props?.cbuCategoryLabel, ...props?.ebuCategoryLabel] },
          ]?.map((item) => {
            return (
              <EbuCbuPieChartTwoHbb
                id={`chartdiv95${item?.text}`}
                width={"100%"}
                height="100%"
                label={item.label}
                text={[item.text]}
                onClick={(category) => {
                  console.log("category", category);
                  setNav([
                    "",
                    category?.includes("CBU") ? "Consumer" : "Corporate",
                    category,
                  ]);
                  // setTableDataType(key);
                }}
              />
            );
          })}
        </div>
      )}
      {nav.length === 2 && nav[nav.length - 1] != "All" && (
        <PieChartHbb
          {...props}
          total={null}
          label={
            nav[1] == "Consumer"
              ? props?.cbuCategoryLabel
              : nav[1] == "Corporate"
              ? props?.ebuCategoryLabel
              : []
          }
          showEbuCbu={showEbuCbu}
          setShowEbuCbu={setShowEbuCbu}
          showColumnChart={showColumnChart}
          setShowColumnChart={setShowColumnChart}
          onNext={onNext}
        />
      )}
      {nav.length === 3 && (
        <EbuCbuPieChartTwoHbb
          label={props?.subcateries?.[nav[nav?.length - 1]]}
          onNext={onNext}
          text={[nav[nav?.length - 1]]}
          onClick={(type) => {
            if (nav[nav?.length - 1]?.includes("WFBB")) {
              setNav([...nav, "Plans"]);
              setTableDataType(nav[nav?.length - 1]);
            } else {
              setNav([...nav, "Service Category"]);
            }
          }}
        />
      )}
      {nav.length === 4 && nav[nav?.length - 1] == "Service Category" && (
        <ServiceCategoryPieChartHbb
          data={
            nav[2]?.includes("CBU")
              ? props?.serviceCbuHbb
              : props?.serviceEbuHbb
          }
          total={
            nav[2]?.includes("CBU")
              ? props?.serviceCbuTotal
              : props?.serviceEbuTotal
          }
          onClickText={() => {
            setNav([...nav, "All Plans"]);
            getCategoryPlans(nav[2]?.includes("CBU") ? "CBU" : "EBU");
          }}
          onNext={() => {
            setNav([...nav, "Plans"]);
            setTableDataType(nav[2]);
          }}
        />
      )}
      {nav[nav?.length - 1] == "Plans" && (
        <HBBPlansTable
          data={props?.hbbPlans[tableDataType]}
          type={tableDataType}
        />
      )}
      {nav[nav?.length - 1] == "All Plans" && (
        <HBBPlansCategoryTable tableRespoonse={props?.categoryPlans} />
      )}
    </div>
  );
}
